module.exports = __webpack_public_path__ + "static/media/Compare_Light.e9476e80.svg";